import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const MaatiSELSessionsConductedPerBatch = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="SEL sessions conducted per batch" />
    </Box>
  );
};
